import { jwtDecode } from 'jwt-decode'

export function useAuthApi() {
  const checkAuthToken = () => {
    const AVAILABLE_TIME_DIFFERENCE_IN_MINUTES = 1

    const { getFromStorage } = useStorage()
    const authToken = getFromStorage(storageKeys.authToken)

    if (!authToken) return false
    
    const { exp } = jwtDecode(authToken)
    const currentTime = Date.now() / 1000
    const differenceInMinutes = Math.floor((exp - currentTime) / 60)

    return differenceInMinutes > AVAILABLE_TIME_DIFFERENCE_IN_MINUTES
  }

  return { checkAuthToken }
}
